import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3_630)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3_630",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M23.0625 0.9375V23.0625H0.9375V0.9375H23.0625Z",
				fill: "white",
				stroke: "white",
				strokeWidth: 1.875
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_3_630)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.7313 6.26877C22.9032 6.44076 22.9998 6.67399 22.9998 6.91718C22.9998 7.16038 22.9032 7.39361 22.7313 7.5656L14.0185 16.2784C13.8465 16.4503 13.6133 16.5469 13.3701 16.5469C13.1269 16.5469 12.8936 16.4503 12.7217 16.2784L8.78439 12.3411L2.55428 18.5712C2.38131 18.7383 2.14964 18.8307 1.90917 18.8287C1.6687 18.8266 1.43867 18.7301 1.26862 18.5601C1.09858 18.39 1.00212 18.16 1.00003 17.9195C0.997945 17.679 1.09039 17.4474 1.25745 17.2744L8.13597 10.3959C8.30796 10.2239 8.5412 10.1274 8.78439 10.1274C9.02758 10.1274 9.26081 10.2239 9.4328 10.3959L13.3701 14.3331L21.4344 6.26877C21.6064 6.09683 21.8397 6.00024 22.0829 6.00024C22.3261 6.00024 22.5593 6.09683 22.7313 6.26877Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.6628 6.91714C15.6628 6.6739 15.7595 6.44062 15.9315 6.26862C16.1035 6.09663 16.3367 6 16.58 6H22.0828C22.326 6 22.5593 6.09663 22.7313 6.26862C22.9033 6.44062 22.9999 6.6739 22.9999 6.91714V12.42C22.9999 12.6632 22.9033 12.8965 22.7313 13.0685C22.5593 13.2405 22.326 13.3371 22.0828 13.3371C21.8396 13.3371 21.6063 13.2405 21.4343 13.0685C21.2623 12.8965 21.1657 12.6632 21.1657 12.42V7.83427H16.58C16.3367 7.83427 16.1035 7.73765 15.9315 7.56565C15.7595 7.39365 15.6628 7.16038 15.6628 6.91714Z",
				fill: "currentColor"
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3_630",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgChartUp;
